import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Her rota (yol) değişiminde sayfayı en üste kaydırır.
// Böylece yeni açılan sayfa önceki sayfanın scroll pozisyonundan devam etmez.
function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}

export default ScrollToTop;
